const TECHDOCS_ANNOTATION = "backstage.io/techdocs-ref";
const TECHDOCS_EXTERNAL_ANNOTATION = "backstage.io/techdocs-entity";

export { TECHDOCS_ANNOTATION, TECHDOCS_EXTERNAL_ANNOTATION };
//# sourceMappingURL=constants.esm.js.map
